import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export class WholesaleLimitResource extends BaseCamelCasedResource {
    pk() {
        return `${this.customerId}`;
    }
}
WholesaleLimitResource.urlRoot = apiResourceUrl("wholesaleLimit/{vendorId}");
//# sourceMappingURL=WholesaleLimitResource.js.map